import { ModalDirective } from 'ng2-bootstrap/components/modal';
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { TermsConditionPopup } from "../models/terms-condition-popup.service";
import {
  IKeyValueInterface,
  IAPIResponse,
  ApplicationRouteURL,
  WeGoConfig
} from "../../shared/config";
import { AuthService } from "./../../shared/models/auth.service";
import { TranslateService } from '../../shared/translate';

@Component({
  selector: 'wego-terms-condition-revoke-popup',
  template: require('../views/terms-and-conditions-revoke-popup.component.html'),
  providers: [TermsConditionPopup,]
})

export class TermsAndConditionsRevokePopup implements OnInit {

  popupMsg: any;
  termsAndConditionHashId: string;
  termsAndConditionName: string;
  acceptanceMoment: string;
  errorMessage: string;
  isEditable: boolean;
  @ViewChild('termsConditionModel') public termsConditionModel: ModalDirective;
  @ViewChild("childModal") public childModal: any;
  @Output('onConfirm') onConfirm = new EventEmitter();

  bodyHTMLText: string;

  constructor(
    private translate: TranslateService,
    private termsConditionPopup: TermsConditionPopup,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.popupMsg = this.translate.instant('LblSureToRevoke');
  }

  private Confirm($event: any) {
    this.childModal.show()
  }

  private HideChildModal() {
    this.childModal.hide();
    this.hide();
  }

  public RevokeTermsAndConditions() {
    this.termsConditionPopup.RevokeTermsAndConditions(this.termsAndConditionHashId).subscribe(
      res => {
        if (res.data) {
          this.HideChildModal();
          this.hide();
          this.onConfirm.emit();
        }
      },
      error => {
        this.errorMessage = error;
      }
    );
  }

  public show(termsAndConditionHashId: string) {
    this.termsAndConditionHashId = termsAndConditionHashId;
    this.GerTermsAndConditionDetail();
  }

  public GerTermsAndConditionDetail() {
    if (this.termsAndConditionHashId != "") {
      this.termsConditionPopup.GetTermsAndConditionsActivityByHashId(this.termsAndConditionHashId).subscribe(
        res => {
          if (res.data) {
            this.popupMsg = this.translate.instant('LblSureToRevoke',[res.data.type]);
            this.termsAndConditionName = res.data.termsAndConditionName;
            this.acceptanceMoment = res.data.actionDateTime;
            this.bodyHTMLText = res.data.bodyHtml;
            this.isEditable = res.data.isEditable;
            this.termsConditionModel.show();
          }
        },
        error => {
          this.errorMessage = error;
        }
      );
    }
  }

  public hide() {
    this.termsConditionModel.hide();
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/termsconditionpopup/components/terms-and-conditions-revoke-popup.component.ts